import { render, staticRenderFns } from "./AppliedRecordHistoryView.vue?vue&type=template&id=cab66974&scoped=true&"
import script from "./AppliedRecordHistoryView.vue?vue&type=script&lang=js&"
export * from "./AppliedRecordHistoryView.vue?vue&type=script&lang=js&"
import style0 from "./AppliedRecordHistoryView.vue?vue&type=style&index=0&id=cab66974&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab66974",
  null
  
)

export default component.exports